const types = {
	REGISTER_NEW_PATIENT: "REGISTER_NEW_PATIENT",
};

export default types;
